module.exports = __webpack_public_path__ + "img/parcel-t-20.d05a460.webp";